import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Typography } from 'wtb-components';
import uiIcons from 'uiIcons';
import styles from './AddStreetAdditional.module.css';

const AddStreetAdditional = ({ addStreetAdditional }) => {
  const { t: translate } = useTranslation();

  return (
    <div
      className={styles.root}
      role="button"
      id="personal-info-streetadditional-button"
      tabIndex={0}
      onKeyDown={addStreetAdditional}
      onClick={addStreetAdditional}
    >
      <Icon name={uiIcons.addCircle} className={styles.icon} />
      <Typography className={styles.text} variant="caption">{translate('customerInfo.addStreetAdditional')}</Typography>
    </div>
  );
};

export default AddStreetAdditional;
